export default __webpack_public_path__ + "static/media/Trophies of the Hunt.9e81fb3f.jpg";